const obj: any = {};
const myWindow = typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : obj;

export { myWindow as window };
